import React, { PropsWithChildren } from 'react';

export const Container = (props: PropsWithChildren<{ additionalClass?: string }>) => (
    <div className={`container ${props.additionalClass ? props.additionalClass : ''}`}>{props.children}</div>
);
